export default __webpack_public_path__ + "static/media/Harness of Bristling Ire.7ce111d7.jpg";